/**
 * GA4 event tracking helpers for MortgageTools calculators.
 *
 * Wraps window.gtag() with null-safety — no-ops when gtag is undefined
 * (dev/test environments without the GA snippet).
 *
 * Import directly into controllers; no Stimulus registration needed.
 */

function sendToGtag(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args)
  }
}

/**
 * Maps a loan amount to a band label for the loan_band dimension.
 */
export function deriveLoanBand(loanAmount) {
  const n = Number(loanAmount)
  if (!Number.isFinite(n) || n <= 0) return undefined

  if (n < 300_000) return "under_300k"
  if (n < 500_000) return "300k_500k"
  if (n < 700_000) return "500k_700k"
  if (n < 1_000_000) return "700k_1m"
  if (n < 1_500_000) return "1m_1_5m"
  return "over_1_5m"
}

/**
 * Fires `calculator_used` after a successful AJAX calculation.
 */
export function trackCalculatorUsed(calculatorType, { loanAmount, paymentFrequency } = {}) {
  sendToGtag("event", "calculator_used", {
    calculator_type: calculatorType,
    loan_band: deriveLoanBand(loanAmount),
    payment_frequency: paymentFrequency || undefined,
  })
}

/**
 * Fires `share` when the user copies or shares a calculator link.
 */
export function trackShare(calculatorType, method) {
  sendToGtag("event", "share", {
    calculator_type: calculatorType,
    method,
  })
}

/**
 * Fires `begin_checkout` when the user requests a PDF report.
 */
export function trackPdfRequested(calculatorType, reportVariant) {
  sendToGtag("event", "begin_checkout", {
    calculator_type: calculatorType,
    report_variant: reportVariant,
  })
}

/**
 * Fires `file_download` when the PDF download actually starts.
 */
export function trackPdfDownloaded(calculatorType, reportVariant) {
  sendToGtag("event", "file_download", {
    calculator_type: calculatorType,
    report_variant: reportVariant,
  })
}

/**
 * Fires `generate_lead` when the user clicks the adviser-enquiry CTA.
 */
export function trackAdviserCtaClicked(calculatorType, source) {
  sendToGtag("event", "generate_lead", {
    calculator_type: calculatorType,
    source,
  })
}
